import '../App.css';
import Root from '../components/Root';
import Overview from '../components/Overview';
import BudgetsOverview from '../components/BudgetsOverview'
import AboutPage from '../components/AboutPage';
import { RouterProvider, Route, createRoutesFromElements, createBrowserRouter } from 'react-router-dom';

const appRouter = createBrowserRouter(createRoutesFromElements(
  <Route path='/' element={<Root/>}>
    <Route index element={<Overview />} />
    <Route path='/about' element={<AboutPage />} />
    <Route path='/budgets' element={<BudgetsOverview />} />
  </Route>
))

function App() {
  return (
    <>
      <RouterProvider router={appRouter} />
    </>
  );
}

export default App;
